import { injectGlobal } from 'emotion';

injectGlobal`
	html, body {
		margin: 0;
		padding: 0;
	}
`
